import { SHIPPING_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const shippingApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getShippingCities: builder.query({
            query: () => ({
                url: `${SHIPPING_URL}/cities`,
            }),
            keepUnusedDataFor: 5,
        }),
    }),
});

export const { useGetShippingCitiesQuery } = shippingApiSlice;
